<template>
  <div id="vue-bridge">
    <AltruisticCreateAccountModal
      v-if="modalSlug === 'friendbuy-create-account'"
      v-bind="modalOptions.props"
    />
    <AltruisticThankYouModal
      v-if="modalSlug === 'friendbuy-thank-you'"
      v-bind="modalOptions.props"
    />
    <LicenseModal
      v-if="modalSlug === 'license-change-plan-modal'"
      v-bind="modalOptions.props"
    />
    <SurveyModal
      v-if="showPreferenceSurvey"
      :campaign-id="surveyCampaignId"
      :complete-survey="completeSurvey"
      :previous-responses="previousSurveyResponses"
      @clickClose="endSurvey"
      @updateResponse="updateSurveyResponse"
    />
    <AdBlockDetector />
  </div>
</template>

<script>
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueMatchHeights from 'vue-match-heights';
import LoadScript from 'vue-plugin-load-script';
import Popover from './components/ui/Popover';
import DealStoryCarousel from './components/pages/dealDetail/DealStoryCarousel.vue';
import AdBlockDetector from './components/utilities/AdBlockDetector.vue';
import * as surveyService from './services/surveyService';

export default {
  name: 'VueBridge',
  components: {
    AltruisticCreateAccountModal: () => import(/* webpackPrefetch: true */ './components/utilities/AltruisticCreateAccountModal.vue'),
    AltruisticThankYouModal: () => import(/* webpackPrefetch: true */ './components/utilities/AltruisticThankYouModal.vue'),
    LicenseModal: () => import(/* webpackPrefetch: true */ './components/license/LicenseModal.vue'),
    SurveyModal: () => import(/* webpackPrefetch: true */ './components/survey/SurveyModal.vue'),
    AdBlockDetector,
  },
  data() {
    return {
      showPreferenceSurvey: false,
      surveyCampaignId: 1,
      surveyId: null,
      previousSurveyResponses: null,
      modalSlug: '',
      modalOptions: {},
      componentSlug: '',
      componentProps: {},
      componentsBySlug: {
        dealDetail: DealStoryCarousel,
      },
    };
  },
  mounted() {
    Vue.use(VueCookies);
    Vue.use(Popover);
    Vue.use(VueMatchHeights);
    Vue.use(LoadScript);
    // expose api
    window.vueAPI = {
      togglePreferenceSurvey: this.togglePreferenceSurvey,
      setupSurvey: this.setupSurvey,
      showModal: this.showModal,
      closeModal: this.closeModal,
      renderComponent: this.renderComponent,
    };
  },
  methods: {
    togglePreferenceSurvey() {
      this.showPreferenceSurvey = !this.showPreferenceSurvey;
    },
    setupSurvey() {
      if (this.$cookies) {
        surveyService.configInstance(this.$cookies);
        this.startSurvey();
      }
    },
    startSurvey() {
      surveyService.create(this.surveyCampaignId, 'started')
        .then((response) => {
          this.surveyId = response.data.user_survey.id;
          this.getPreviousResponses();
        });
    },
    getPreviousResponses() {
      surveyService.getUserSurvey(this.surveyCampaignId, this.surveyId)
        .then((response) => {
          if (response.data && response.data.user_survey) {
            this.previousSurveyResponses = response.data.user_survey.user_responses;
          }
        })
        .finally(() => {
          this.togglePreferenceSurvey();
        });
    },
    completeSurvey() {
      surveyService.changeStatus(this.surveyId, this.surveyCampaignId, 'completed')
        .finally(() => {
          // Maybe we can show a popup here in case of an error
          this.togglePreferenceSurvey();
        });
    },
    endSurvey() {
      surveyService.changeStatus(this.surveyId, this.surveyCampaignId, 'abandoned')
        .finally(() => {
          this.togglePreferenceSurvey();
        });
    },
    updateSurveyResponse(data) {
      surveyService.updateResponse(this.surveyId, data);
    },
    showModal(modalSlug, options) {
      this.modalOptions = options;
      this.modalSlug = modalSlug;
    },
    closeModal() {
      this.modalSlug = '';
      this.modalOptions = {};
    },
    // failed attempt to try and compile, render, then mount a component.
    // renderComponent(componentSlug, idSelector, componentProps) {
    //   this.componentSlug = componentSlug;
    //   this.componentProps = componentProps;
    //   const componentToRender = Vue.extend(this.componentsBySlug[componentSlug]);
    //   const componentInstance = new componentToRender(componentProps);
    //   new Vue(componentInstance).$mount(idSelector)
    // }
  },
};
</script>
